import React, { useState, useEffect } from 'react';
import DataCollection from '../../shared/DataCollection';
import DeathCauseCardList from './DeathCauseCardList.js';
import { useTranslation } from 'react-i18next';

const systemAccount = "000000000000000000000000";

export const ListDeathCauses = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const columns = [
    { name: t("death_cause"), selector: row => t(row.name, { defaultValue: row.name }) },
    { name: t("nicknames"),   selector: row => row.matches },
    {
      name: t("type"),
      selector: row => row.account === systemAccount ? t('breed_type_system') : t('breed_type_custom'),
      sortable: true,
    },
  ];

  return (
    <DataCollection
      collection="death_causes"
      columns={columns}
      sortField={1}
      mobileComponent={(data, onRefresh) => (
        <DeathCauseCardList data={data} onRefresh={onRefresh} />
      )}
    />
  );
}

export default ListDeathCauses;
